import { useSnackbar, SnackbarProvider } from './snackbarSlice';

export { SnackbarProvider };
export default useSnackbar;
